import LogRocket from "logrocket";

import { useEffect, useRef } from "react";
import $api from "./queries/openapi";

export default function LogRocketIntegration({ appId }: { appId: string }) {
  useEffect(() => {
    LogRocket.init(appId);
  }, [appId]);

  // User identification
  const session = useRef<{ userId?: string }>({});
  const userQuery = $api.useQuery("get", "/api/user");
  const currentUser = userQuery.error ? null : userQuery.data!; // after logout query will return 401 but `user` will remain set
  useEffect(() => {
    if (
      session.current.userId &&
      (!currentUser || currentUser.id !== session.current.userId)
    ) {
      // Current session has a user associated, but current user is different (incl. null/logout), start a new session.
      LogRocket.startNewSession();
      session.current = {};
    }

    if (!session.current.userId && currentUser) {
      // Current session does not have a user associated, but current user is logged in, identify the user.
      LogRocket.identify(currentUser.id, {
        name: currentUser.display_name,
        email: currentUser.email,
      });
      session.current.userId = currentUser.id;
    }
  }, [currentUser]);

  return null;
}
